<template>
	<div class="overflow-x-hidden">
		<div class="max-w-7xl px-6 md:px-0 mx-auto z-30 relative">
			<div class="grid grid-cols-1 md:grid-cols-2 overflow-hidden">
				<div class="flex md:mt-12 md:mt-0 md:-mt-36 h-96 md:h-screen min-h-full justify-center items-center">
					<div class="min-h-screen flex flex-col items-left justify-center">
						<h1 class="block font-gilroy-extrabold text-3xl text-center md:text-left">
							A trusted software development company<br>
							with a portfolio of great companies.
						</h1>

						<h2 class="mt-8 block text-inter-500 text-gray-500 text-lg text-center md:text-left">
							We build beautiful applications that empower<br>
							your business and simplify everyday tasks.
						</h2>

						<router-link
							class="mt-8 block relative w-max z-30 md:ml-0 mx-auto bg-gradient-to-br from-blue-500 to-purple-700 text-inter-500 hover:scale-105 hue-rotate transition transform duration-500 text-white text-sm rounded-md py-4 px-4 aos-init aos-animate"
							to="/projects"
						>Explore our projects&nbsp; 🔎</router-link>
					</div>
				</div>
				<div
					class="flex h-screen justify-center items-center p-10 ml-1 hidden overflow-hidden md:flex"
					style="width: 125%;height: calc(100% - 158px);"
				>
					<div class="h-full w-full">
						<div class="relative block">
							<div class="absolute z-10 h-5 w-5 left-12 -mt-6 top-36">
								<span class="cursor-pointer h-5 w-5 block text-sm cursor-pointer rounded-full bg-purple-500 animate text-center text-white">
									<span>1</span>
								</span>
								<span class="cursor-pointer h-5 w-5 block -mt-5 rounded-full bg-purple-500 animate-ping"></span>
							</div>

							<div class="absolute z-10 h-5 w-5 left-48 ml-3 -mt-8 top-72">
								<span class="cursor-pointer h-5 w-5 block text-sm cursor-pointer rounded-full bg-green-500 animate text-center text-white">
									<span>2</span>
								</span>
								<span class="cursor-pointer h-5 w-5 block -mt-5 rounded-full bg-green-500 animate-ping"></span>
							</div>

							<div class="absolute z-10 h-5 w-5 right-0 top-36">
								<span class="cursor-pointer h-5 w-5 block text-sm cursor-pointer rounded-full bg-green-500 animate text-center text-white">
									<span>3</span>
								</span>
								<span class="cursor-pointer h-5 w-5 block -mt-5 rounded-full bg-green-500 animate-ping"></span>
							</div>
						</div>
						<!--hover:scale-105 transform transition duration-500-->
						<img
							src="images/assets/sakura.png"
							class=" block mx-auto absolute -right-64 top-2 z-0 bg-white w-8/12"
						>
					</div>

				</div>

				<div class="flex md:hidden">
					<img
						src="images/assets/sakura.png"
						class=" block -ml-6 mx-auto absolute z-0 bg-white w-12/12"
					>
				</div>
			</div>
		</div>

		<div class="h-full md:h-24 mt-80 md:-mt-12 w-full block p-3 bg-gray-200 relative z-30">
			<div class="flex flex-col md:flex-row mx-auto max-w-max">
				<div class="md:max-w-7xl md:ml-32 md:px-0 md:mr-32 mt-3 z-30 relative flex flex-wrap md:flex-row justify-center items-center">
					<div class="align-middle inline-block mb-3 mr-3 md:mb-0 max-w-max md:w-4/12 md:mr-6">
						<a href="https://www.bursa.ro/de-la-olimpic-multimedaliat-la-dezvoltatorul-unei-platforme-pentru-fermieri-andrei-patrascu-am-participat-la-olimpiada-de-tic-sa-nu-raman-corigent-pentru-ca-am-spart-site-ul-liceului-45170047">
							<img
								src="images/logos/bursa.png"
								class="w-36  hover:scale-110 transform transition duration-500"
							>
						</a>
					</div>
					<div class="align-middle inline-block mb-3 mr-3 md:mb-0 max-w-max md:w-4/12 md:mr-6">
						<a href="https://start-up.ro/farmeria-ro-piata-digitala-destinata-producatorilor-locali-de-alimente/">
							<img
								src="images/logos/start-up.png"
								class="w-36  hover:scale-110 transform transition duration-500"
							>
						</a>
					</div>
					<div class="align-middle inline-block mb-3 mr-3 md:mb-0 max-w-max md:w-4/12 md:mr-6">
						<a href="https://www.transilvaniabusiness.ro/2020/04/08/platforma-comerciala-online-destinata-producatorilor-locali-de-alimente-naturale/">
							<img
								src="images/logos/transilvania_business.png"
								class="w-36 hover:scale-110 transform transition duration-500"
							>
						</a>
					</div>
					<div class="align-middle inline-block mb-3 mr-3 md:mb-0 max-w-max md:w-4/12 md:mr-6">
						<a href="https://www.g4media.ro/trei-tineri-antreprenori-au-lansat-farmeria-ro-o-platforma-comerciala-online-destinata-producatorilor-locali-de-alimente-naturale.html">
							<img
								src="images/logos/g4media.png"
								class="w-36  hover:scale-110 transform transition duration-500"
							>
						</a>
					</div>
					<div class="align-middle inline-block mb-3 mr-3 md:mb-0 max-w-max md:w-4/12 md:mr-6">
						<a href="https://adevarul.ro/locale/focsani/s-au-stabilit-castigatorii-concursului-national-infoeducatie-printre-premiati-afla-elev-focsani-dezvoltat-platforma-producatori-1_5eba7cf35163ec4271b39ce8/index.html">
							<img
								src="images/logos/adevarul.png"
								class="w-36 hover:scale-110 transform transition duration-500"
							>
						</a>
					</div>
					<div class="align-middle inline-block mb-3 mr-3 md:mb-0 max-w-max md:w-4/12 md:mr-6">
						<a href="https://ziare.com/internet-si-tehnologie/stiri-it-c/povestea-elevului-olimpic-care-a-creat-o-piata-online-pentru-toata-romania-de-10-ani-face-it-si-nu-are-in-plan-sa-plece-din-tara-1607278">
							<img
								src="images/logos/ziarecom.png"
								class="w-36 hover:scale-110 transform transition duration-500"
							>
						</a>
					</div>
				</div>
				<div class="flex justify-center mt-12 md:mt-3 items-center">
					<a href="https://anis.ro">
						<img
							src="images/logos/anis.png"
							class="w-36 hover:scale-110 transform transition duration-500"
						>
					</a>
				</div>
			</div>
		</div>

		<div class="relative px-6 md:px-0 bg-black h-full overflow-hidden">

			<h1
				class="mt-16 font-gilroy-extrabold text-white relative z-30 text-5xl text-center"
				data-aos="fade-down"
				data-aos-duration="1500"
			> We'll be your new tech partner.</h1>
			<p
				class="mt-12 text-justify md:text-center font-roboto-regular text-gray-300 text-xl relative z-30 max-w-2xl text-center mx-auto block"
				data-aos="fade-down"
				data-aos-duration="2000"
			>Codestage is a software development company that develops top-notch and innovative products. We are trusted by big companies to deliver high-quality work on time.</p>

			<router-link
				data-aos="fade-down"
				data-aos-duration="2500"
				class="mt-12 block relative z-30 mx-auto block bg-gradient-to-br from-blue-500 to-purple-700 text-inter-500 hover:scale-105 transition transform duration-500 max-w-max text-white text-lg rounded-md py-4 px-10"
				to="/projects"
			>
				See our work
			</router-link>
			<transition name="fade">
				<div
					v-observe-visibility="{ callback: isViewableNow, once: true }"
					class="flex relative mt-16"
				>
					<div :class="{ 'glow': showAnimation }"></div>
					<svg
						width="3120"
						height="761"
						viewBox="0 0 3120 761"
						fill="none"
						stroke="#5E6AD2"
						xmlns="http://www.w3.org/2000/svg"
						:class="{ 'svg-anime': showAnimation }"
					>
						<line
							style="animation-delay:0.0s"
							y1="0.5"
							x2="3120"
							y2="0.5"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.02s"
							y1="77.5"
							x2="3120"
							y2="77.5"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.04s"
							y1="690.5"
							x2="3120"
							y2="690.5"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.08s"
							y1="760.5"
							x2="3120"
							y2="760.5"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.10s"
							y1="632.5"
							x2="3120"
							y2="632.5"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.12s"
							x1="1036.5"
							y1="1"
							x2="1036.5"
							y2="764"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.14s"
							x1="2076.5"
							y1="1"
							x2="2076.5"
							y2="760"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.16s"
							x1="829.758"
							y1="760.563"
							x2="1060.76"
							y2="632.563"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.16s"
							x1="829.758"
							y2="128"
							x2="1060.76"
							y1="0"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.18s"
							x1="1078.68"
							y1="760.617"
							x2="1231.68"
							y2="632.617"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.18s"
							x1="1078.68"
							y2="128"
							x2="1231.68"
							y1="0"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.20s"
							x1="1268.59"
							y1="760.708"
							x2="1360.59"
							y2="632.708"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.20s"
							x1="1268.59"
							y2="128"
							x2="1360.59"
							y1="0"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.22s"
							x1="1420.54"
							y1="760.797"
							x2="1477.54"
							y2="632.797"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.22s"
							x1="1420.54"
							y2="128"
							x2="1477.54"
							y1="0"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.24s"
							x1="2048.25"
							y1="632.568"
							x2="2267.25"
							y2="760.568"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.24s"
							x2="2048.25"
							y2="128"
							x1="2267.25"
							y1="0"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.26s"
							x1="1561.5"
							y1="634"
							x2="1561.5"
							y2="761"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.26s"
							x1="1561.5"
							y2="127"
							x2="1561.5"
							y1="0"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.28s"
							x1="1885.32"
							y1="632.616"
							x2="2042.32"
							y2="763.62"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.28s"
							x2="1885.32"
							y2="131"
							x1="2042.32"
							y1="0"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.30s"
							x1="1751.41"
							y1="632.708"
							x2="1843.41"
							y2="760.708"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.30s"
							x2="1751.41"
							y2="128"
							x1="1843.41"
							y1="0"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.32s"
							x1="1652.48"
							y1="632.844"
							x2="1694.48"
							y2="760.844"
							:class="{ 'svg-anime': showAnimation }"
						></line>
						<line
							style="animation-delay:0.32s"
							x2="1652.48"
							y2="128"
							x1="1694.48"
							y1="0"
							:class="{ 'svg-anime': showAnimation }"
						></line>
					</svg>
					<img
						:class="{ 'glow_img': showAnimation }"
						src="images/assets/sakura.png"
					>
				</div>
			</transition>

			<div class="md:h-36"></div>
		</div>

		<div class="px-6 md:px-0">
			<div class="md:ml-24 mt-16 h-full md:h-screen w-full">
				<div class="flex flex-col md:flex-row h-full items-center">
					<div class="w-12/12 md:w-4/12">
						<div class="md:max-w-md">
							<h1
								class="font-gilroy-extrabold text-5xl text-center md:text-left"
								data-aos="fade-right"
								data-aos-duration="1500"
							>We've Helped<br>Big Companies With Their Tech Needs</h1>

							<p
								data-aos="fade-right"
								data-aos-duration="2000"
								class="mt-12 text-inter-500 max-w-lg text-justify md:text-left leading-6 text-gray-500"
							>
								Three of the biggest wine producers in Romania — <a
									href="https://vinarte.ro"
									class="text-blue-500"
									target="_blank"
								>Vinarte</a>, <a
									href="https://serve.ro"
									class="text-blue-500"
									target="_blank"
								>Serve</a> & Crama Oprisor needed to find a mechanism in order to enhance their order stream. Along with our partners from
								<a
									href="https://ar-studio.net"
									class="text-blue-500"
									target="_blank"
								>AR Studio</a> & <a
									href="https://t2studios.ro"
									class="text-blue-500"
									target="_blank"
								>T2 Studios</a>, we've built a custom, headless e-commerce platform available both on web and mobile.
							</p>
							<a
								data-aos="fade-right"
								data-aos-duration="2500"
								class="mt-12 hue-rotate block text-inter-500 md:ml-0 mx-auto hover:scale-105 transition transform duration-500 max-w-max text-white rounded py-3 px-4"
								style="background-image: url(images/gradients/redblue.png)"
								href="https://3pentruvin.ro"
							>
								Visit the platform
							</a>
						</div>
					</div>
					<div class="hidden md:block md:w-8/12 h-5/6">
						<div
							class="rounded-3xl p-7 h-full bg-cover hue-rotate"
							style="background-image: url(images/gradients/redblue.png);"
						>
							<img src="images/assets/treipentruvin.png">
						</div>
					</div>
				</div>
			</div>

			<div class="min-h-screen flex flex-col items-center justify-center">

				<h1
					class="mt-32 font-gilroy-extrabold text-black relative z-30 text-5xl text-center"
					data-aos="fade-down"
					data-aos-duration="1500"
				> Our olympics & awards </h1>
				<p
					class="mt-12 font-roboto-regular text-gray-600 text-xl relative z-30 max-w-2xl text-center mx-auto block"
					data-aos="fade-down"
					data-aos-duration="2000"
				>Our team is made up of former internationally-awarded olympics in robotics, IT&C and web software.</p>

				<vue-glide v-bind="carouselOptions" class="max-w-5xl text-center mx-auto bg-gray-100 rounded-lg mt-6">
					<vue-glide-slide class="p-5">
						<div class="bg-white shadow-lg rounded-lg p-3 w-full">
							<span class="text-yellow-500 text-xl font-gilroy-extrabold block">Gold medal</span>
							<span class="font-roboto-regular block mt-4">National Applied Informatics Olympiad</span>
							<span class="text-xl font-roboto-regular block mt-4">2019</span>
						</div>
					</vue-glide-slide>
					<vue-glide-slide class="p-5">
						<div class="bg-white shadow-lg rounded p-3 w-full">
							<span class="text-gray-500 text-xl font-gilroy-extrabold block">Silver medal</span>
							<span class="font-roboto-regular block mt-4">National Applied Informatics Olympiad</span>
							<span class="text-xl font-roboto-regular block mt-4">2017</span>
						</div>
					</vue-glide-slide>
					<vue-glide-slide class="p-5">
						<div class="bg-white shadow-lg rounded p-3 w-full">
							<span class="text-yellow-700 text-xl font-gilroy-extrabold block">Bronze medal</span>
							<span class="font-roboto-regular block mt-4">National Applied Informatics Olympiad</span>
							<span class="text-xl font-roboto-regular block mt-4">2018</span>
						</div>
					</vue-glide-slide>
					<vue-glide-slide class="p-5">
						<div class="bg-white shadow-lg rounded p-3 w-full">
							<span class="text-yellow-500 text-xl font-gilroy-extrabold block">2nd place</span>
							<span class="font-roboto-regular block mt-4">International Robotics "ROBOTOR" Trophy</span>
							<span class="text-xl font-roboto-regular block mt-4">2017</span>
						</div>
					</vue-glide-slide>
					<vue-glide-slide class="p-5">
						<div class="bg-white shadow-lg rounded p-3 w-full">
							<span class="text-yellow-500 text-xl font-gilroy-extrabold block">1st place</span>
							<span class="font-roboto-regular block mt-4">"InfoEducatie" National Software Contest - WEB Section - County phase</span>
							<span class="text-xl font-roboto-regular block mt-4">2019</span>
						</div>
					</vue-glide-slide>
					<vue-glide-slide class="p-5">
						<div class="bg-white shadow-lg rounded p-3 w-full">
							<span class="text-yellow-500 text-xl font-gilroy-extrabold block">1st place</span>
							<span class="font-roboto-regular block mt-4">"InfoEducatie" National Software Contest - WEB Section - County phase</span>
							<span class="text-xl font-roboto-regular block mt-4">2018</span>
						</div>
					</vue-glide-slide>
					<vue-glide-slide class="p-5">
						<div class="bg-white shadow-lg rounded p-3 w-full">
							<span class="text-yellow-500 text-xl font-gilroy-extrabold block">1st place</span>
							<span class="font-roboto-regular block mt-4">"InfoEducatie" National Software Contest - WEB Section - County phase</span>
							<span class="text-xl font-roboto-regular block mt-4">2017</span>
						</div>
					</vue-glide-slide>
					<vue-glide-slide class="p-5">
						<div class="bg-white shadow-lg rounded p-3 w-full">
							<span class="text-yellow-500 text-xl font-gilroy-extrabold block">1st place</span>
							<span class="font-roboto-regular block mt-4">National Applied Informatics Olympiad - Country phase</span>
							<span class="text-xl font-roboto-regular block mt-4">2019</span>
						</div>
					</vue-glide-slide>
					<vue-glide-slide class="p-5">
						<div class="bg-white shadow-lg rounded p-3 w-full">
							<span class="text-yellow-500 text-xl font-gilroy-extrabold block">1st place</span>
							<span class="font-roboto-regular block mt-4">National Applied Informatics Olympiad - Country phase</span>
							<span class="text-xl font-roboto-regular block mt-4">2018</span>
						</div>
					</vue-glide-slide>
					<vue-glide-slide class="p-5">
						<div class="bg-white shadow-lg rounded p-3 w-full">
							<span class="text-yellow-500 text-xl font-gilroy-extrabold block">1st place</span>
							<span class="font-roboto-regular block mt-4">National Applied Informatics Olympiad - Country phase</span>
							<span class="text-xl font-roboto-regular block mt-4">2017</span>
						</div>
					</vue-glide-slide>
					<vue-glide-slide class="p-5">
						<div class="bg-white shadow-lg rounded p-3 w-full">
							<span class="text-gray-500 text-xl font-gilroy-extrabold block">Mention</span>
							<span class="font-roboto-regular block mt-4">"InfoEducatie" National Software Contest - WEB Section</span>
							<span class="text-xl font-roboto-regular block mt-4">2017</span>
						</div>
					</vue-glide-slide>
					<vue-glide-slide class="p-5">
						<div class="bg-white shadow-lg rounded p-3 w-full">
							<span class="text-gray-500 text-xl font-gilroy-extrabold block">Mention</span>
							<span class="font-roboto-regular block mt-4">"InfoEducatie" National Software Contest - WEB Section</span>
							<span class="text-xl font-roboto-regular block mt-4">2018</span>
						</div>
					</vue-glide-slide>
					<vue-glide-slide class="p-5">
						<div class="bg-white shadow-lg rounded p-3 w-full">
							<span class="text-gray-500 text-xl font-gilroy-extrabold block">Mention</span>
							<span class="font-roboto-regular block mt-4">"InfoEducatie" National Software Contest - WEB Section</span>
							<span class="text-xl font-roboto-regular block mt-4">2019</span>
						</div>
					</vue-glide-slide>
					<vue-glide-slide class="p-5">
						<div class="bg-white shadow-lg rounded p-3 w-full">
							<span class="text-gray-500 text-xl font-gilroy-extrabold block">Mention</span>
							<span class="font-roboto-regular block mt-4">"InfoEducatie" National Software Contest - WEB Section </span>
							<span class="text-xl font-roboto-regular block mt-4">2020</span>
						</div>
					</vue-glide-slide>
				</vue-glide>
			</div>

			<div class="md:-ml-20 mt-16 h-screen w-full">
				<div class="flex h-full items-center">
					<div class="hidden md:block md:w-8/12 h-5/6">
						<div
							class="rounded-3xl p-7 h-full bg-cover hue-rotate"
							style="background-image: url(images/gradients/redblue.png);"
						>
							<img src="images/assets/treipentruvin.png">
						</div>
					</div>
					<div class="w-12/12 md:ml-24 md:w-4/12">
						<div class="md:max-w-md">
							<h1
								class="text-center md:text-right font-gilroy-extrabold text-5xl"
								data-aos="fade-left"
								data-aos-duration="1500"
							>We've Helped<br>Big Companies With Their Tech Needs</h1>

							<p
								data-aos="fade-left"
								data-aos-duration="2000"
								class="text-justify md:text-right mt-12 text-inter-500 leading-6 text-gray-500"
							>
								Three of the biggest wine producers in Romania — Vinarte, Serve & Crama Oprisor needed to find a mechanism in order to enhance their order stream. Along with our partners from AR Studio & T2 Studios, we've built a custom, headless e-commerce platform available both on web and mobile.
							</p>
							<a
								data-aos="fade-left"
								data-aos-duration="2500"
								class="mt-12 hue-rotate block text-inter-500 md:mr-0 mx-auto hover:scale-105 transition transform duration-500 max-w-max text-white rounded py-3 px-4"
								style="background-image: url(images/gradients/redblue.png)"
								href="https://3pentruvin.ro"
							>
								Visit the platform
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="max-w-7xl mx-auto px-6 md:px-0 z-30 relative">
			<div class="mt-16">
				<div
					data-aos="fade-down"
					data-aos-duration="1500"
					class="w-full overflow-hidden h-auto rounded-lg relative bg-gradient-to-br from-purple-500 via-purple-600 to-purple-700 p-10"
				>
					<div class="flex flex-col md:flex-row h-auto">
						<div class="w-12/12 md:w-3/12">
							<img
								data-aos="fade-right"
								data-aos-duration="1500"
								src="images/logos/logo_white.png"
								class="w-5/12 mb-6 md:mb-0 md:w-7/12 mx-auto md:mt-16 md:ml-12 align-center align-middle"
							>
						</div>
						<div class="w-12/12 md:w-9/12 z-10">
							<div
								data-aos="fade-up"
								data-aos-duration="2500"
								class="bg-white shadow-xl h-auto rounded-lg p-4 md:p-10"
							>
								<h2 class="font-gilroy-extrabold text-2xl text-center md:text-left md:text-3xl">The Cloud™ expansion program</h2>
								<p class="mt-8 text-inter-500 text-justify leading-6 max-w-2xl text-gray-600 text-md">
									Codestage is an innovative software development company based in Bucharest. <br> We're continuously expanding The Cloud™ and recruiting young programmers who want to become a part of the next generation of technology. <br> Codestage - where professionals and newbies come together to build their careers as The Cloud™.
								</p>
								<a
									href="#"
									class="transform mx-auto md:ml-0 transition duration-500 hover:scale-105 hover:bg-purple-500 bg-purple-600 text-center w-44 p-3 text-white rounded-lg mt-10 block text-inter-500 text-md"
								>Learn more</a>
							</div>
						</div>
					</div>
					<div class="w-full z-0 top-0 absolute">
						<div
							v-for="i in 40"
							:key="i"
							:class="'meteor-' + i"
						></div>
					</div>
				</div>
			</div>
		</div>

		<div class="max-w-7xl mx-auto px-6 md:px-0 z-30 relative">
			<div class="mt-20">
				<!--<div class="max-w-max-content mb-5">
					<div class=" align-middle mr-3 inline-block bg-black rounded-xl h-12 w-12 p-3 hover:bg-purple-500 duration-500 transform transition hover:scale-105">
						<img src="images/icons/product.png">
					</div>
					<h2 class="align-middle inline-block text-3xl font-bold font-gilroy-extrabold">Recent news</h2>
				</div>-->

				<h1
					class="font-gilroy-extrabold text-black relative z-30 text-5xl text-center"
					data-aos="fade-down"
					data-aos-duration="1500"
				> They wrote about us</h1>

				<div class="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4">
					<div
						class="bg-gray-200 p-3 rounded-lg"
						data-aos="fade-down"
						data-aos-duration="1000"
					>
						<a href="https://www.g4media.ro/trei-tineri-antreprenori-au-lansat-farmeria-ro-o-platforma-comerciala-online-destinata-producatorilor-locali-de-alimente-naturale.html">
							<div
								class="bg-gray-300 h-48 rounded-lg bg-cover bg-center"
								style="background-image: url('images/news/g4media.jpg');"
							></div>

							<h2 class="font-bold text-lg mt-2 font-gilroy-extrabold leading-5">Three young entrepreneurs launched Farmeria.ro (RO)</h2>
							<span class="font-roboto-regular text-sm tracking-wide text-justify block">
								via G4Media.ro
							</span>
						</a>
					</div>

					<div
						class="bg-gray-200 p-3 rounded-lg"
						data-aos="fade-down"
						data-aos-duration="1500"
					>
						<a href="https://www.bursa.ro/de-la-olimpic-multimedaliat-la-dezvoltatorul-unei-platforme-pentru-fermieri-andrei-patrascu-am-participat-la-olimpiada-de-tic-sa-nu-raman-corigent-pentru-ca-am-spart-site-ul-liceului-45170047">
							<div
								class="bg-gray-300 h-48 rounded-lg bg-cover bg-center"
								style="background-image: url('images/news/bursa.jpg');"
							></div>

							<h2 class="font-bold text-lg mt-2 font-gilroy-extrabold leading-5">From a multiawarded olympic to the developer of a platform for farmers (RO)</h2>
							<span class="font-roboto-regular text-sm tracking-wide text-justify block">
								via Bursa.ro
							</span>
						</a>
					</div>

					<div
						class="bg-gray-200 p-3 rounded-lg"
						data-aos="fade-down"
						data-aos-duration="2000"
					>
						<a href="https://ziare.com/internet-si-tehnologie/stiri-it-c/povestea-elevului-olimpic-care-a-creat-o-piata-online-pentru-toata-romania-de-10-ani-face-it-si-nu-are-in-plan-sa-plece-din-tara-1607278">
							<div
								class="bg-gray-300 h-48 rounded-lg bg-cover bg-center"
								style="background-image: url('images/news/g4media.jpg');"
							></div>

							<h2 class="font-bold text-lg mt-2 font-gilroy-extrabold leading-5">Doing IT for 10 years and not planning to leave the country (RO)</h2>
							<span class="font-roboto-regular text-sm tracking-wide text-justify block">
								via Ziare.com
							</span>
						</a>
					</div>
				</div>
			</div>

			<!--<div class="mt-16">
				<div class="max-w-max-content mb-5">
					<div class=" align-middle mr-3 inline-block bg-black rounded-xl h-12 w-12 p-3 hover:bg-purple-500 duration-500 transform transition hover:scale-105">
						<img src="images/icons/gear.png">
					</div>
					<h2 class="align-middle inline-block text-3xl font-bold font-gilroy-extrabold">Technologies</h2>
				</div>

				<div class="grid grid-cols-1 px-3 md:px-0 md:grid-cols-5 gap-8 mt-16">
					<div class="bg-gray-200 h-48 relative p-3 rounded-lg mb-7 md:mb-0 hover:bg-green-100 transform transition hover:scale-105 duration-500">
						<img
							src="images/technologies/vue.png"
							class="block mx-auto -mt-12 w-48"
						>

						<span class="font-gilroy-extrabold text-lg bottom-3 left-1/3 text-center block mt-5">Vue.js</span>
					</div>

					<div class="bg-gray-200 h-48 relative p-3 rounded-lg mb-7 md:mb-0 hover:bg-red-100 transform transition hover:scale-105 duration-500">
						<img
							src="images/technologies/angular.png"
							class="block mx-auto -mt-20 w-48"
						>

						<span class="font-gilroy-extrabold text-lg absolute bottom-3 left-1/3 text-center block mt-5">Angular.js</span>
					</div>

					<div class="bg-gray-200 h-48 relative p-3 rounded-lg mb-7 md:mb-0 hover:bg-red-200 transform transition hover:scale-105 duration-500">
						<img
							src="images/technologies/laravel.png"
							class="block mx-auto -mt-12 w-36"
						>

						<span class="font-gilroy-extrabold text-lg absolute bottom-3 left-1/3 text-center block mt-5">Laravel</span>
					</div>

					<div class="bg-gray-200 h-48 relative p-3 rounded-lg mb-7 md:mb-0 hover:bg-purple-100 transform transition hover:scale-105 duration-500">
						<img
							src="images/technologies/inertia.png"
							class="block mx-auto -mt-12 w-36"
						>

						<span class="font-gilroy-extrabold text-lg absolute bottom-3 left-1/3 text-center block mt-5">Inertia.js</span>
					</div>

					<div class="bg-gray-200 h-48 relative p-3 rounded-lg hover:bg-blue-100 transform transition hover:scale-105 duration-500">
						<img
							src="images/technologies/tailwind.png"
							class="block mx-auto -mt-12 w-48"
						>

						<span class="font-gilroy-extrabold text-lg absolute bottom-3 left-1/3 text-center block mt-5">Tailwindcss</span>
					</div>
				</div>
			</div>-->
		</div>

		<div class="h-full p-4 md:p-0 bg-black mt-16">

			<div class="h-12 md:h-24"></div>

			<div class="max-w-lg mx-auto relative">
				<div
					data-aos="fade-down"
					data-aos-duration="1000"
					class="flex flex-col md:flex-row justify-center transition transfrom hover:scale-105 duration-500 items-center rounded-lg p-2 relative z-30"
					style="background:#0B0B0C"
				>
					<div class="w-3/12 md:w-2/12">
						<img
							class="w-3/6 mx-auto"
							src="images/logos/logo_color.png"
						>
					</div>
					<div class="mt-4 md:mt-0 w-12/12 md:w-10/12 text-center">
						<span class="text-inter-500 text-gray-300 text-sm">
							The market's favorite software development company.
						</span>
					</div>
				</div>
				<div
					data-aos="fade-down"
					data-aos-duration="3000"
					class="gradient-border z-0"
				></div>
			</div>

			<div class="flex mt-12 items-center justify-center ">
				<div>
					<a
						href="https://www.trustpilot.com/review/codestage.ro"
						target="_blank"
						rel="noopener"
					>
						<img
							src="images/logos/trustpilot.png"
							class="w-80"
							data-aos="fade-right"
							data-aos-duration="1000"
						>
					</a>
				</div>
				<div
					data-aos="fade-left"
					data-aos-duration="1000"
				>
					<!-- TrustBox widget - Micro Review Count -->
					<div
						class="trustpilot-widget"
						data-locale="en-US"
						data-template-id="5419b6a8b0d04a076446a9ad"
						data-businessunit-id="5fe7169d5d8ca50001287e8f"
						data-style-height="24px"
						data-style-width="100%"
						data-theme="dark"
					>
						<a
							href="https://www.trustpilot.com/review/codestage.ro"
							target="_blank"
							rel="noopener"
						>Trustpilot</a>
					</div>
					<!-- End TrustBox widget -->
				</div>
			</div>
			<div class="h-12 md:h-28">
			</div>
		</div>

		<div class="w-screen h-full relative overflow-hidden">
			<div class="h-36"></div>
			<div class="max-w-7xl h-full mx-auto px-6 md:px-0 z-30 relative">
				<div class="flex flex-col md:flex-row h-full justify-center items-center">
					<div
						class="w-12/12 md:w-4/12"
						data-aos="fade-right"
						data-aos-duration="1000"
					>
						<span class="block uppercase text-purple-600 text-center md:text-left font-roboto-regular">Trusted companies</span>
						<h2 class="font-gilroy-extrabold text-center md:text-left text-black text-3xl">Powering companies & organisations of all sizes</h2>
					</div>
					<div class="w-12/12 md:w-8/12 mt-12 md:mt-12 flex flex-row items-center justify-center md:justify-end">
						<div class="w-2/12 mr-4 md:h-48 md:relative">
							<a
								href="https://osdubb.ro"
								target="_blank"
							>
								<img
									data-aos="fade-down"
									data-aos-duration="750"
									class="w-full"
									src="images/logos/osdubb.png"
								>
							</a>

							<span class="hidden rounded-full md:absolute bottom-0 w-full px-3 bg-gray-300 text-xs py-1 text-center block mt-4">EDUCATION</span>
						</div>
						<div class="w-2/12 mr-4 md:h-48 md:relative">
							<a
								href="https://consiliulelevilor.ro"
								target="_blank"
							>
								<img
									data-aos="fade-down"
									data-aos-duration="1000"
									class="w-8/12 mx-auto"
									src="images/logos/cne.png"
								>
							</a>

							<span class="hidden rounded-full md:absolute bottom-0 w-full px-3 bg-gray-300 text-xs py-1 text-center block mt-4">EDUCATION</span>
						</div>

						<div class="w-2/12 mr-8 md:h-48 md:relative">
							<a
								href="https://vangardio.com"
								target="_blank"
							>
								<img
									data-aos="fade-down"
									data-aos-duration="2000"
									class="w-full md:mt-6"
									src="images/logos/vangardio.png"
								>
							</a>

							<span class="hidden rounded-full md:absolute bottom-0 w-full px-3 bg-gray-300 text-xs py-1 text-center block mt-4">REAL ESTATE</span>
						</div>
						<div class="w-2/12 md:h-48 md:relative">
							<img
								data-aos="fade-down"
								data-aos-duration="1500"
								class="w-full md:mt-12"
								src="images/logos/javu.png"
							>

							<span class="hidden rounded-full md:absolute bottom-0 w-full px-3 bg-gray-300 text-xs py-1 text-center block mt-4">HORECA</span>
						</div>
					</div>
				</div>
			</div>
			<div class="mt-28 h-36">
				<a
					data-aos="fade-down"
					data-aos-duration="3000"
					class="mt-8 block relative mx-auto z-30 block bg-gradient-to-br from-blue-500 to-purple-700 text-inter-500 hover:scale-105 text-lg transition transform duration-500 max-w-max text-white text-sm rounded-md py-4 px-12"
					href="https://ar-studio.net"
				>
					See our clients
				</a>
			</div>
		</div>

		<div class="bg-black h-full px-6 md:px-0">
			<div class="h-16"></div>
			<h1
				class="font-gilroy-extrabold text-white relative z-30 text-5xl text-center"
				data-aos="fade-down"
				data-aos-duration="1500"
			> Go beyond the clouds with your favorite teams.</h1>
			<p
				class="mt-12 font-roboto-regular text-gray-300 text-xl relative z-30 max-w-4xl text-center mx-auto block"
				data-aos="fade-down"
				data-aos-duration="2000"
			> Along with our partners from <a
					href="https://ar-studio.net"
					class="text-blue-500"
					target="_blank"
				>AR Studio</a> and <a
					href="https://t2studios.ro/"
					class="text-blue-500"
					target="_blank"
				>T2 Studios</a>, we provide cutting-edge software development services and solutions to businesses of all sizes. We use our proven experience and expertise to deliver high quality results for every project we take on. </p>

			<div
				class="mt-12 max-w-sm mx-auto"
				data-aos="fade-down"
				data-aos-duration="2500"
			>
				<div class="flex">

					<div class="w-6/12">
						<div class="relative mx-auto w-max">
							<div
								@click="switchPartner('ar')"
								class="w-24 cursor-pointer h-24 relative z-30 rounded-full p-3"
								style="background-color:#0b0b0f"
							>
								<img
									class="mt-2 w-12/12"
									src="images/logos/arstudio.png"
								>
							</div>

							<div
								class="gradient-border rounded-full z-0"
								style="animation: 2s gradient-pulse;filter:blur(10px)"
							></div>
						</div>
					</div>
					<div class="w-6/12">
						<div class="relative mx-auto w-max">
							<div
								@click="switchPartner('t2')"
								class="w-24 cursor-pointer h-24 relative z-30 rounded-full p-3"
								style="background-color:#0b0b0f"
							>
								<img
									class="mt-1 w-12/12"
									src="images/logos/t2.png"
								>
							</div>

							<div
								class="gradient-border rounded-full z-0"
								style="animation: 2s gradient-pulse;filter:blur(10px)"
							></div>
						</div>
					</div>
				</div>
			</div>

			<div class="relative p-3 md:p-0 mt-16 mx-auto max-w-3xl">
				<div
					data-aos="fade-up"
					data-aos-duration="1000"
					style="background:#0b0b0f"
					class="p-1 relative z-30 rounded-md"
				>
					<div class="flex flex-col md:flex-row py-12 px-8">
						<div class="w-12/12 md:w-4/12">
							<img
								v-if="partnerShown == 't2'"
								class="w-6/12 mx-auto md:w-10/12"
								src="images/logos/t2.png"
							>
							<img
								data-aos="fade-right"
								data-aos-duration="1000"
								v-if="partnerShown == 'ar'"
								class="w-10/12 mt-12"
								src="images/logos/arstudio.png"
							>
						</div>
						<div class="w-12/12 md:w-8/12">
							<h1
								data-aos="fade-left"
								data-aos-duration="1000"
								v-if="partnerShown == 't2'"
								class="font-gilroy-extrabold text-center md:text-left text-white text-2xl"
							>T2 Studios</h1>
							<h1
								data-aos="fade-left"
								data-aos-duration="1000"
								v-if="partnerShown == 'ar'"
								class="font-gilroy-extrabold text-center md:text-left text-white text-2xl"
							>AR Studio</h1>

							<p
								data-aos="fade-left"
								data-aos-duration="1500"
								v-if="partnerShown == 't2'"
								class="mt-4 text-inter-500 text-justify md:text-left text-gray-400 text-sm"
							> The T2 Studios team is currently developing mobile apps for startups and businesses of all sizes. They have a range of tools that can help with any kind of development work, from creating prototypes to full-scale applications. </p>
							<p
								data-aos="fade-left"
								data-aos-duration="1500"
								v-if="partnerShown == 'ar'"
								class="mt-4 text-inter-500 text-justify md:text-left text-gray-400 text-sm"
							> AR Studio offers professional augmented reality development services, utilizing the latest AR technology to develop innovative and interactive solutions for your business. AR Studios creates a bridge between real and virtual worlds by developing cutting-edge applications in all spheres of life - from marketing to healthcare, education, retail and beyond. </p>

							<a
								v-if="partnerShown == 't2'"
								data-aos="fade-left"
								data-aos-duration="2500"
								class="mt-4 block relative z-30 block mx-auto md:ml-0 bg-gradient-to-br from-blue-500 to-purple-700 text-inter-500 hover:scale-105 transition transform duration-500 max-w-max text-white text-sm rounded-md py-2 px-5"
								href="https://t2studios.ro"
							>
								Visit T2's website
							</a>

							<a
								v-if="partnerShown == 'ar'"
								data-aos="fade-down"
								data-aos-duration="2500"
								class="mt-4 block relative z-30 block mx-auto md:ml-0 bg-gradient-to-br from-blue-500 to-purple-700 text-inter-500 hover:scale-105 transition transform duration-500 max-w-max text-white text-sm rounded-md py-2 px-5"
								href="https://ar-studio.net"
							>
								Visit AR Studio's website
							</a>
						</div>
					</div>
				</div>
				<div
					data-aos="fade-up"
					data-aos-duration="2000"
					class="gradient-border z-0"
				></div>
			</div>
			<div class="h-12"></div>

		</div>

		<Contact />
	</div>
</template>

<script>

import Vue from 'vue'
import { Glide, GlideSlide } from 'vue-glide-js'
import 'vue-glide-js/dist/vue-glide.css'
import VueObserveVisibility from 'vue-observe-visibility'
import Contact from '@/components/Contact'

Vue.use(VueObserveVisibility)

export default {
	components: {
		[Glide.name]: Glide,
		[GlideSlide.name]: GlideSlide,
		Contact
	},
	data() {
		return {
			partnerShown: 'ar',
			showAnimation: false,
			carouselOptions:{
                perView: this.isMobile() ? 1 : 3,
            },
		}
	},
	methods: {
		switchPartner: function (e) {
			this.partnerShown = e;
		},
		isViewableNow(isVisible) {
			console.log(isVisible)
			this.showAnimation = isVisible;
		},
		isMobile() {
			if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				return true
			} else {
				return false
			}
		}
	}
}
</script>